/*
 *
 * MyAccount reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_USER_WATCHER,
  GET_USER_SUCCESS,
  GET_USER_FAILED,
  PUT_USER_WATCHER,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
  PUT_LANGUAGE_WATCHER,
  PUT_LANGUAGE_SUCCESS,
  PUT_LANGUAGE_FAILED,
} from "./constants"

export const initialState = fromJS({
  user: {},
  languages: [],
  isLoadingLanguage: true,
  isLoadingUser: true,
})

function myAccountReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LANGUAGE_WATCHER:
      return state.set("isLoadingLanguage", true)
    case GET_LANGUAGE_SUCCESS:
      return state
        .set("languages", action.payload)
        .set("isLoadingLanguage", false)
    case GET_LANGUAGE_FAILED:
      return state.set("isLoadingLanguage", false).set("languages", [])
    case GET_USER_WATCHER:
    case PUT_USER_WATCHER:
      return (
        state
          // .set('user', {})
          .set("isLoadingUser", true)
      )
    case GET_USER_SUCCESS:
      return state.set("user", action.payload).set("isLoadingUser", false)
    case GET_USER_FAILED:
      return state.set("user", {}).set("isLoadingUser", false)
    default:
      return state
  }
}

export default myAccountReducer
